<template>
  <!-- <v-app-bar absolute color="transparent" flat height="85">
    <v-container>
      <v-row align="center">
        <v-toolbar-title class="font-weight-light" v-text="title" />

        <v-spacer />

        <v-btn
          v-for="(item, i) in itemsMostrar()"
          :key="i"
          :to="item.to"
          class="hidden-sm-and-down"
          min-height="48"
          text
        >
          <template>
            <v-icon left size="20" v-text="item.icon" />

            <span v-text="item.text" />
          </template>
        </v-btn>
      </v-row>
    </v-container>
  </v-app-bar> -->
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "PagesCoreAppBar",

  data: () => ({
    items: [
      {
        icon: "mdi-view-home",
        text: "INICIO",
        to: "/"
      },
      {
        icon: "mdi-currency-usd",
        text: "COMO FUNCIONA",
        to: "/pricing"
      },
      {
        icon: "mdi-account-multiple-plus",
        text: "REGISTRATE",
        to: "/register",
        mostrar: {
          admin: false,
          gestor: false,
          cliente: false,
          anonimo: true
        }
      },
      {
        icon: "mdi-fingerprint",
        text: "Login",
        to: "/login",
        mostrar: {
          admin: false,
          gestor: false,
          cliente: false,
          anonimo: true
        }
      },
      {
        icon: "mdi-view-dashboard",
        text: "Panel de Administración",
        to: "/admin/panel",
        mostrar: {
          admin: true,
          boss_restaurante: true,
          boss_negocio: true,
          gestor: true,
          cliente: false,
          anonimo: false
        }
      }
    ],
    titles: {
      "/front/lock": "Lock Page",
      "/front/login": "Login Page",
      "/front/pricing": "Pricing Page",
      "/front/register": "Register Page"
    }
  }),

  computed: {
    ...mapState({
      isLogged: state => state.auth.isLogged
    }),
    ...mapGetters({
      role: "auth/role"
    }),
    title() {
      return this.titles[this.$route.path];
    }
  },
  methods: {
    itemsMostrar() {
      let a = this.items;
      let res = [];
      a.forEach(element => {
        let aux = element;
        console.log(aux);
        let mostrar;
        if (this.isLogged) {
          mostrar = element.mostrar ? element.mostrar[this.role] : false;
        } else {
          mostrar = element.mostrar ? element.mostrar.anonimo : true;
        }
        if (mostrar) res.push(aux);
      });
      return res;
    },
    comprobarMostrar(item) {
      if (item.mostrar) {
        if (this.isLogged) {
          return item.mostrar[this.role];
        } else {
          return item.mostrar.anonimo;
        }
        mostrar.login;
      } else {
        return true;
      }
    }
  }
};
</script>
